import {TankRelease} from "./getTankReleaseList";
import axios from "axios";
import {BaseResponse} from "../../BaseResponse";

export async function putTankRelease(tankReleaseId: string, tankRelease: TankRelease) {
    const response = await axios.put<BaseResponse<boolean>>(`/tank/release/${tankReleaseId}`, tankRelease)

    return response.data
}